import { useState } from 'react'
import { Trans } from '@lingui/react/macro'

import { useFeatures, useGetConfig } from '@jotta/grpc-connect-client/config'
import { useBrandName } from '@jotta/grpc-connect-client/config'
import type { Field } from '@jotta/hooks/useForm'
import { DeprecatedDialog } from '@jotta/ui/DeprecatedDialog'
import { FormFieldErrorMessage } from '@jotta/ui/Label'
import { Modal } from '@jotta/ui/Modal'

import { JottaTermsAndConditions } from '../terms/JottaTermsAndConditions'

import type { newsletterField, useAcceptedTermsField } from './signupForm'

export function TermsAndConditionsCheckbox({
  acceptedTerms,
  newsletter,
}: {
  acceptedTerms: Field<ReturnType<typeof useAcceptedTermsField>>
  newsletter: Field<typeof newsletterField>
}) {
  const [open, setOpen] = useState(false)
  const { newsletter: newsletterFeature } = useFeatures()
  const { data: getConfigResponse } = useGetConfig()
  const actualBrandName = useBrandName()

  const brandingInfo = getConfigResponse?.brandingInfo
  const termsLink = brandingInfo?.termsLink
  const isJotta = brandingInfo?.brandCode === 'JOTTACLOUD'
  const isMediamarkt = brandingInfo?.brandCode === 'MEDIAMARKT'
  const isLetsGo = brandingInfo?.brandCode === 'LETS_GO'
  const brand = isMediamarkt || isLetsGo ? 'Jottacloud' : actualBrandName
  const acceptedTermsError = acceptedTerms.error
  const newsletterError = newsletter.error

  return (
    <div>
      <label className="checkbox">
        <input type="checkbox" {...acceptedTerms.inputProps} />
        <span>
          <Trans>
            I have read and accepted {brand}'s{' '}
            <a
              href={termsLink || '/terms'}
              className="!text-signup-link underline"
              target="_blank"
              rel="noreferrer"
              onClick={event => {
                if (isJotta) {
                  event.preventDefault()
                  setOpen(true)
                }
              }}
            >
              terms and conditions
            </a>
          </Trans>
        </span>
      </label>
      {acceptedTermsError && (
        <FormFieldErrorMessage
          className="col-span-2"
          errorMessage={acceptedTermsError.view}
        />
      )}

      {newsletterFeature && (
        <>
          <label className="checkbox">
            <input type="checkbox" {...newsletter.inputProps} />
            <Trans>
              I would like to receive email updates with news and information
              about {brand}
            </Trans>
          </label>
          {newsletterError && (
            <FormFieldErrorMessage
              className="col-span-2"
              errorMessage={newsletterError.view}
            />
          )}
        </>
      )}

      <Modal open={open} onClose={() => setOpen(false)}>
        <DeprecatedDialog
          className="!max-w-screen-lg !p-0"
          onClose={() => setOpen(false)}
        >
          <JottaTermsAndConditions />
        </DeprecatedDialog>
      </Modal>
    </div>
  )
}
